module.exports = __webpack_public_path__ + "media/video-carousel-one.5e0c9bb4.mp4";